import { driver } from "driver.js";
import "driver.js/dist/driver.css";

export function startTourActivarEmpresa(navigate, uid) {
  const profilePath = `/perfil/${uid}`;

  if (window.location.pathname === profilePath) {
    setTimeout(() => startActivarEmpresaFase1(), 400);
  } else {
    sessionStorage.setItem("aw_pending_tour", "activar-empresa-fase1");
    navigate(profilePath);
  }
}

export function startActivarEmpresaFase1() {
  let tabClickHandler = null;
  let gridClickHandler = null;

  const cleanupTabListener = () => {
    const btn = document.querySelector('[data-tour-id="tab-empresas"]');
    if (btn && tabClickHandler) {
      btn.removeEventListener("click", tabClickHandler);
      tabClickHandler = null;
    }
  };

  const cleanupGridListener = () => {
    const grid = document.querySelector('[data-tour-id="empresas-grid"]');
    if (grid && gridClickHandler) {
      grid.removeEventListener("click", gridClickHandler);
      gridClickHandler = null;
    }
  };

  const driverObj = driver({
    showProgress: true,
    nextBtnText: "Siguiente →",
    prevBtnText: "← Anterior",
    doneBtnText: "¡Listo!",
    progressText: "{{current}} de {{total}}",
    allowClose: false,
    onDestroyStarted: () => {
      cleanupTabListener();
      cleanupGridListener();
      driverObj.destroy();
    },
    steps: [
      {
        element: '[data-tour-id="tab-empresas"]',
        popover: {
          title: "🏢 Pestaña Empresas",
          description:
            "Haz clic en la pestaña \"Empresas\" para ver tus empresas creadas.",
          side: "bottom",
          align: "start",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          const btn = document.querySelector('[data-tour-id="tab-empresas"]');
          if (!btn) return;
          tabClickHandler = () => {
            cleanupTabListener();
            setTimeout(() => driverObj.moveNext(), 500);
          };
          btn.addEventListener("click", tabClickHandler);
        },
        onDeselected: () => {
          cleanupTabListener();
        },
      },
      {
        element: '[data-tour-id="empresas-grid"]',
        popover: {
          title: "🏢 Tus Empresas",
          description:
            "Aquí puedes ver todas tus empresas. Haz clic en una empresa para ir a su página y activarla.",
          side: "top",
          align: "start",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          const grid = document.querySelector('[data-tour-id="empresas-grid"]');
          if (!grid) return;
          gridClickHandler = (e) => {
            const card = e.target.closest("a, button, [role='link']");
            if (!card) return;
            cleanupGridListener();
            sessionStorage.setItem("aw_pending_tour", "activar-empresa-fase2");
            driverObj.destroy();
          };
          grid.addEventListener("click", gridClickHandler);
        },
        onDeselected: () => {
          cleanupGridListener();
        },
      },
    ],
  });

  driverObj.drive();
}

export function startActivarEmpresaFase2() {
  let menuClickHandler = null;
  let optionClickHandler = null;

  const cleanupMenuListener = () => {
    const btn = document.querySelector('[data-tour-id="perfil-menu-trigger"]');
    if (btn && menuClickHandler) {
      btn.removeEventListener("click", menuClickHandler);
      menuClickHandler = null;
    }
  };

  const cleanupOptionListener = () => {
    const opt = document.querySelector(
      ':is([data-tour-id="menu-activar-empresa"], [data-tour-id="menu-empresa-en-revision"])',
    );
    if (opt && optionClickHandler) {
      opt.removeEventListener("click", optionClickHandler);
      optionClickHandler = null;
    }
  };

  const driverObj = driver({
    showProgress: true,
    nextBtnText: "Siguiente →",
    prevBtnText: "← Anterior",
    doneBtnText: "¡Listo!",
    progressText: "{{current}} de {{total}}",
    allowClose: false,
    onDestroyStarted: () => {
      cleanupMenuListener();
      cleanupOptionListener();
      driverObj.destroy();
    },
    steps: [
      {
        element: '[data-tour-id="perfil-menu-trigger"]',
        popover: {
          title: "⋯ Menú de opciones",
          description:
            "Haz clic en este botón para abrir el menú de opciones de tu empresa.",
          side: "bottom",
          align: "end",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          const btn = document.querySelector(
            '[data-tour-id="perfil-menu-trigger"]',
          );
          if (!btn) return;
          menuClickHandler = () => {
            cleanupMenuListener();
            setTimeout(() => driverObj.moveNext(), 400);
          };
          btn.addEventListener("click", menuClickHandler);
        },
        onDeselected: () => {
          cleanupMenuListener();
        },
      },
      {
        element:
          ':is([data-tour-id="menu-activar-empresa"], [data-tour-id="menu-empresa-en-revision"])',
        popover: {
          title: "🏢 Activar Empresa",
          description:
            "Aquí encontrarás la opción para activar tu empresa. Si ya enviaste la solicitud, verás \"En Revisión\" — tu empresa está siendo revisada por el equipo de AppWhoop. Si aún no la has enviado, haz clic en \"Activar Empresa\" para iniciar el proceso.",
          side: "left",
          align: "start",
          showButtons: ["close"],
        },
        onHighlightStarted: () => {
          const opt = document.querySelector(
            ':is([data-tour-id="menu-activar-empresa"], [data-tour-id="menu-empresa-en-revision"])',
          );
          if (!opt) return;
          optionClickHandler = () => {
            cleanupOptionListener();
            driverObj.destroy();
          };
          opt.addEventListener("click", optionClickHandler);
        },
        onDeselected: () => {
          cleanupOptionListener();
        },
      },
    ],
  });

  driverObj.drive();
}
